import { white } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid';
import { sharpSansSemibold } from '@zocdoc/components/src/typography';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { LOCALIZED_STRINGS } from './constants';

export default class NextAvailabilityView extends React.PureComponent {
    static propTypes = {
        getNextAvailability: PropTypes.func.isRequired,
        insuranceCarrier: PropTypes.string,
        insurancePlan: PropTypes.string,
        isNewPatient: PropTypes.bool,
        locationId: PropTypes.string.isRequired,
        nextAvailability: PropTypes.string,
        procedureId: PropTypes.string,
        provider: PropTypes.object.isRequired,
        referrerType: PropTypes.string,
        widget: PropTypes.string,
    }

    componentDidMount() {
        this.fetchAvailability(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isNewPatient !== prevProps.isNewPatient ||
            this.props.locationId !== prevProps.locationId ||
            this.props.procedureId !== prevProps.procedureId) {
            this.fetchAvailability(this.props);
        }
    }

    getLocationMonolithId(provider, id) {
        const { locations } = provider;
        const location = locations.filter(loc => loc.id === id)[0];
        return location.monolithId;
    }

    fetchAvailability(props) {
        const {
            getNextAvailability,
            locationId,
            provider,
            ...otherProps
        } = props;

        if (provider.isBookable && provider.locations.length > 0) {
            const passingProps = {
                ...otherProps,
                providerId: provider.monolithId,
                locationId: this.getLocationMonolithId(provider, locationId),
            };

            getNextAvailability(passingProps);
        }
    }

    render() {
        const { nextAvailability } = this.props;

        if (nextAvailability) {
            return (
                <AvailabilityWrapper>
                    <AvailabilityText data-test="next-availability">
                        <FormattedMessage
                            {...LOCALIZED_STRINGS.NextAvailabilityIs}
                            values={{ time: nextAvailability }}
                        />
                    </AvailabilityText>
                </AvailabilityWrapper>
            );
        }

        return this.props.alternate;
    }
}

const lineHeight = '44px';

const AvailabilityWrapper = styled.div`
    ${sharpSansSemibold(15, 12)}
    display: block;
    text-align: center;
    margin: 0 16px;
    letter-spacing: 0.5px;
    height: ${lineHeight};
    background: linear-gradient(to bottom, ${white}, rgba(255, 255, 255, 0.5));
    color: ${p => p.theme.profile.textColor};
    margin: 0;

    ${breakpoint.medium} {
        display: none !important;
    }
`;

const AvailabilityText = styled.span`
    line-height: ${lineHeight};
`;
